import React from 'react';
import classNames from 'classnames';

import ZpButton from 'components/zpButton';

import { DessertWithTumble } from '../../svg';

import classes from './index.module.css';

interface NoJobProps {
  errorTitle?: string;
  errorMessage?: string;
  showUndoButton?: boolean;
  showResetButton?: boolean;
  updatePreference?: boolean;
  updateProfile?: () => boolean;
  undoFilter?: () => void;
  resetFilter?: () => void;
}

const defaultProps: NoJobProps = {
  errorTitle: 'No Results',
  errorMessage: 'Aw snap, found nothing.',
  showResetButton: false,
  showUndoButton: false,
  undoFilter: () => {},
  resetFilter: () => {},
};

const NoJob: React.FC<NoJobProps> = ({
  errorTitle,
  errorMessage,
  showUndoButton,
  showResetButton,
  updatePreference,
  updateProfile,
  undoFilter,
  resetFilter,
}: NoJobProps) => (
  <div className={classNames(classes.noResults, 'z-px-0 clearfix')}>
    <p className="brandonH2">{errorTitle}</p>
    <p className={classes.noJobsMessage}>{errorMessage}</p>
    {showUndoButton && (
      <ZpButton
        theme="super-primary"
        type="button"
        className="super-primary-button-small"
        onClick={undoFilter}
      >
        Undo Filter
      </ZpButton>
    )}
    {showResetButton && (
      <ZpButton
        theme="secondary"
        className={classNames(
          `secondary-button-small`,
          showUndoButton ? classes.noResultsButtonSpacing : ''
        )}
        type="button"
        onClick={resetFilter}
      >
        Reset
      </ZpButton>
    )}
    {updatePreference && (
      <ZpButton
        theme="secondary"
        className={classNames(
          `secondary-button-small`,
          showUndoButton ? classes.noResultsButtonSpacing : ''
        )}
        type="button"
        onClick={updateProfile}
      >
        Update Preference
      </ZpButton>
    )}
    <div className={classes.noResultsTumbleweed}>
      <div className={classes.svgAnimation}>
        <DessertWithTumble />
      </div>
    </div>
  </div>
);

NoJob.defaultProps = defaultProps;

export default NoJob;
